import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import {
  DollarSign,
  ShoppingBag,
  Package,
  UserCircle,
  PackageCheck,
  TicketSlash,
  SquarePen,
} from "lucide-react";
import { useUserServices } from "../context/DealerProfile";

const Dashboard = () => {
  const {
    dealerDetail: { accountName, dealerName, endCustomerShipping },
    priceItem,
  } = useUserServices();
  const [filter, setFilter] = useState("this-month");
  const [grandTotal, setGrandTotal] = useState(0);
  const [totalvalue, settotalvalue] = useState(0);
  const [, setData] = useState([]);
  const [order, setOrder] = useState(0);
  const [endcustomer, setEndCustomer] = useState(0);
  const [confirmorder, setConfirmOrder] = useState(0);
  const [picking, setPicking] = useState(0);
  const [invoice, setInvoice] = useState(0);
  const [pandingorder, setpandingorder] = useState(0);
  // const [totalItem, setTotalItem] = useState(0);
  const [yearWiseData, setYearWiseData] = useState({});

  // console.log({ priceItem });
  // Function to fetch dashboard revenue
  const DashboardRevenu = async () => {
    try {
      // Fetch the data from the server with the filter
      const response = await fetch(
        `/server/dealer_backend/dashboardrevenu?filter=${filter}&accountid=${
          dealerName?.id === null ? accountName?.id : dealerName?.id
        }`
      );
      const result = await response.json();

      // console.log({ result });

      if (result.success && result.data) {
        setData(result.data);
        const total = result.data
          .filter((item) => item.Stage !== "Void" && item.Stage !== "Cancelled")
          .reduce((sum, item) => sum + (Number(item.Grand_Total) || 0), 0);

        setGrandTotal(total);
        const order = result.data.filter(
          (item) => item.Stage !== "Void" && item.Stage !== "Cancelled"
        );
        setOrder(order.length || 0);

        //Pandingorders Order
        const pandingorder = result.data.filter(
          (item) => item.Stage === "Pending For Availability Check"
        );
        setpandingorder(pandingorder.length || 0);
        //confirm Order
        const confirmorder = result.data.filter(
          (item) => item.Stage === "Order Confirm"
        );
        setConfirmOrder(confirmorder.length || 0);
        //Picking Order
        const picking = result.data.filter(
          (item) => item.Stage === "Order : Picking"
        );
        setPicking(picking.length || 0);
        //Invoice Order
        const invoice = result.data.filter(
          (item) => item.Stage === "Order : Invoiced"
        );
        setInvoice(invoice.length || 0);
      } else {
        console.error("Failed to fetch dashboard revenue:", result.message);
        setData([]); // Set empty array
        setGrandTotal(0);
        setOrder(0);
        setpandingorder(0);
        setConfirmOrder(0);
        setPicking(0);
        setInvoice(0);
      }
    } catch (error) {
      console.error("Error fetching dashboard revenue:", error);
      setData([]);
      setGrandTotal(0);
      setOrder(0);
      setpandingorder(0);
      setConfirmOrder(0);
      setPicking(0);
      setInvoice(0);
    }
  };
  const returndash = async () => {
    try {
      // Fetch the data from the server with the filter
      const response = await fetch(
        `/server/dealer_backend/return-dash?filter=${encodeURIComponent(
          filter
        )}&accountid=${dealerName?.id ?? accountName?.id}`
      );
      const result = await response.json();

      // console.log("ReturnDash", result?.data?.data);

      // Ensure result.data is an array before filtering
      if (Array.isArray(result?.data?.data)) {
        const Dashboard = result?.data?.data.filter(
          (item) => item?.Return_Status === "Approved"
        );

        // console.log("Pending Returns:", Dashboard);

        // Calculate total (assuming there's a 'Total_Amount' field)
        const totalAmount = Dashboard.reduce(
          (sum, item) => sum + (item?.Grand_Total ?? 0),
          0
        );

        // console.log("Total Pending Return Amount: $", totalAmount.toFixed(2));
        settotalvalue(totalAmount.toFixed(2));
      }
    } catch (error) {
      console.error("Error fetching dashboard revenue:", error);
    }
  };
  //EndCustomer
  // setEndCustomer(endCustomerShipping.length);
  // const EndCustomer = async () => {
  //   try {
  //     // Fetch the data from the server with the filter
  //     const response = await fetch(`/server/dealer_backend/endcustomer`);
  //     const result = await response.json();
  //     if (result.data) {
  //       const endcustomer = result?.data?.filter(
  //         (item) =>
  //           item.Address_Type == "End Customer" && item.End_Customer !== null
  //       );
  //       setEndCustomer(endcustomer.length);
  //       console.log({ endcustomer });
  //     } else {
  //       console.error("Failed to fetch dashboard revenue:", result.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching dashboard revenue:", error);
  //   }
  // };

  useEffect(() => {
    DashboardRevenu();
    returndash();
  }, [filter]);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  useEffect(() => {
    const fetchYearWiseData = async () => {
      try {
        // Fetch data from the backend
        const response = await fetch(
          `/server/dealer_backend/yearwisedata?filter=${selectedYear}&accountid=${
            dealerName?.id === null ? accountName?.id : dealerName?.id
          }`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch year-wise data");
        }
        const data = await response.json();
        console.log("data.......", data.monthlyData);
        // console.log("Fetched data:", data.year, data.monthlyData);
        if (data.year && data.monthlyData) {
          const yearDatas = Array(12)
            .fill(0)
            .map((_, index) => {
              return Array.isArray(data.monthlyData[index + 1])
                ? data.monthlyData[index + 1].length
                : 0;
            });

          const formattedData = {
            [data.year]: [
              {
                name: "Orders",
                data: yearDatas,
              },
            ],
          };

          // Update the state with the formatted data
          setYearWiseData(formattedData);
        } else {
          console.error("Invalid data structure:", data);
          setYearWiseData({});
        }
      } catch (error) {
        console.error("Error fetching year-wise data:", error);
      }
    };
    fetchYearWiseData();
  }, [selectedYear]);

  useEffect(() => {
    if (yearWiseData[selectedYear]) {
      setChartOptions((prevState) => ({
        ...prevState,
        series: yearWiseData[selectedYear],
      }));
    } else {
      setChartOptions((prevState) => ({
        ...prevState,
        series: [],
      }));
    }
  }, [yearWiseData, selectedYear]);

  const [chartOptions, setChartOptions] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: "area",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      xaxis: {
        categories: months,
        labels: {
          formatter: (value) => value,
        },
      },
      tooltip: {
        x: {
          format: "MMM",
        },
      },
    },
  });

  // Handle Year Change
  const handleYearChange = (e) => {
    const selectedYear = e.target.value;
    setSelectedYear(selectedYear);
  };

  // Monthly Return Orders Reports

  const [, setReturnYearData] = useState(null);
  const [monthCart, setMonthCart] = useState({
    series: [
      {
        name: "Return",
        data: [], // Placeholder for initial data
      },
    ],
    chart: {
      height: 350,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}`,
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      position: "bottom",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "horizontal",
        shadeIntensity: 0.25,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [50, 0, 100, 100],
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: (val) => `${val}`,
      },
    },
  });

  const fetchYearReturn = async () => {
    try {
      const response = await fetch(
        `/server/dealer_backend/yearreturn?accountid=${
          dealerName?.id === null ? accountName?.id : dealerName?.id
        }`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch year-wise data");
      }

      const data = await response.json();
      console.log("Fetched data:", data);

      if (data?.year && data?.monthlyData) {
        // Format data for chart
        const yearDatas = Array(12)
          .fill(0)
          .map((_, index) => data?.monthlyData[index + 1]?.length || 0);

        setReturnYearData({
          name: "Return",
          data: yearDatas,
        });

        setMonthCart((prevOptions) => ({
          ...prevOptions,
          series: [
            {
              name: "Return",
              data: yearDatas,
            },
          ],
        }));
      } else {
        console.error("Invalid data structure:", data);
      }
    } catch (error) {
      console.error("Error fetching year-wise data:", error);
    }
  };

  useEffect(() => {
    fetchYearReturn();
  }, []);

  // Donut chart data configuration
  const donutChartOptions = {
    series: [pandingorder, confirmorder, picking, invoice],
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
    },
    // labels: ['Product A', 'Product B', 'Product C', 'Product D', 'Product E'],
    labels: [
      "Pending Orders",
      "Confirm Orders",
      "Picked Orders",
      "Invoiced Orders",
    ],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
            toolbar: {
              show: false,
            },
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  const getLastFiveYearsOptions = () => {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = 0; i < 5; i++) {
      const yearValue = currentYear - i;
      options.push(
        <option key={yearValue} value={yearValue}>
          {yearValue}
        </option>
      );
    }
    return options;
  };

  function formatToIndianNumberingSystem(number) {
    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  // Get Draft Order's
  const [draf, setdraft] = useState(0);
  useEffect(() => {
    // Fetch drafted orders from local storage
    const loadDraftedOrders = () => {
      const draftedOrders = [];
      for (let key in localStorage) {
        if (key.startsWith("order_")) {
          const order = JSON.parse(localStorage.getItem(key));
          // convert order id
          order["uid"] = order["uid"].replace("order_", "");
          draftedOrders.push(order);
        }
      }
      // console.log({draftedOrders});
      setdraft(draftedOrders);
      // setIsLoading(false);
    };

    loadDraftedOrders();
  }, []);
  return (
    <>
      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h2 className="text-lg text-gray-500">
              Welcome back,{" "}
              {`${dealerName?.id ? dealerName?.name : accountName?.name}`} !
            </h2>
            <h1 className="text-3xl font-bold">Dashboard</h1>
          </div>
          {/* Filter Dropdown */}
          <div className="w-[180px] mb-4">
            <select
              className="w-full py-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-blue-500"
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="this-month">This Month</option>
              <option value="last-month">Last Month</option>
              <option value="this-year">This Year</option>
            </select>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Revenue Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-green-50 rounded-lg">
                <DollarSign className="w-6 h-6 text-green-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  Total Order Value
                  {/* <span className="text-green-500 text-xs">↑3.84%</span> */}
                </p>
                <p className="text-2xl font-bold">
                  $
                  {formatToIndianNumberingSystem(
                    Math.max(
                      0,
                      Math.floor((grandTotal || 0) - (totalvalue || 0))
                    )
                  )}
                </p>
              </div>
            </div>
          </div>

          {/* Orders Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-purple-50 rounded-lg">
                <ShoppingBag className="w-6 h-6 text-purple-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  Orders
                  {/* <span className="text-green-500 text-xs">↑1.46%</span> */}
                </p>
                <p className="text-2xl font-bold">
                  {order.toString().replace(/[^\w\s]/g, "")}
                </p>
              </div>
            </div>
          </div>

          {/* Items Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-orange-50 rounded-lg">
                <Package className="w-6 h-6 text-orange-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  Pending Orders
                  {/* <span className="text-gray-500 text-xs">↔0.0%</span> */}
                </p>
                <p className="text-2xl font-bold">{pandingorder}</p>
              </div>
            </div>
          </div>
          {/* Items Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-orange-50 rounded-lg">
                <PackageCheck className="w-6 h-6 text-green-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  Confirm Orders
                  {/* <span className="text-gray-500 text-xs">↔0.0%</span> */}
                </p>
                <p className="text-2xl font-bold">{confirmorder}</p>
              </div>
            </div>
          </div>
          {/* Items Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-orange-50 rounded-lg">
                <Package className="w-6 h-6 text-red-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  Picked Orders
                  {/* <span className="text-gray-500 text-xs">↔0.0%</span> */}
                </p>
                <p className="text-2xl font-bold">{picking}</p>
              </div>
            </div>
          </div>
          {/* Items Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-orange-50 rounded-lg">
                <TicketSlash className="w-6 h-6 text-orange-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  Invoiced Orders
                  {/* <span className="text-gray-500 text-xs">↔0.0%</span> */}
                </p>
                <p className="text-2xl font-bold">{invoice}</p>
              </div>
            </div>
          </div>

          {/* Users Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-pink-50 rounded-lg">
                <UserCircle className="w-6 h-6 text-pink-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  No of End Customers
                  {/* <span className="text-red-500 text-xs">↓0.5%</span> */}
                </p>
                <p className="text-2xl font-bold">
                  {endCustomerShipping.length}
                </p>
              </div>
            </div>
          </div>
          {/* Users Card */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              <div className="p-2 bg-pink-50 rounded-lg">
                {/* <UserCircle  /> */}
                <SquarePen className="w-6 h-6 text-red-500" />
              </div>
              <div>
                <p className="text-sm text-gray-500 flex items-center gap-1">
                  Draft Orders
                  {/* <span className="text-red-500 text-xs">↓0.5%</span> */}
                </p>
                <p className="text-2xl font-bold">{draf.length}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-6">
        {/* Sales Analytics Section */}
        <div className="mt-4">
          <div className="bg-white shadow rounded-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h6 className="font-bold">Month Wise Orders</h6>
              <select
                className="form-select block w-auto px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                value={selectedYear}
                onChange={handleYearChange}
              >
                {getLastFiveYearsOptions()}
              </select>
            </div>
            <ReactApexChart
              options={chartOptions.options}
              series={chartOptions.series}
              type="area"
              height={350}
            />
          </div>
        </div>

        {/* Monthly Sales and Top Products Section */}
        <div className="mt-6 grid grid-cols-1 xl:grid-cols-2 gap-4">
          {/* Monthly Sales Report Card */}
          <div className="bg-white shadow rounded-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h6 className="font-semibold">
                Monthly Return Orders Report{" "}
                <sup>{new Date().getFullYear()}</sup>
              </h6>
              {/* <div className="text-end">
                <h5 className="text-xl font-bold">2384</h5>
                <h6 className="text-gray-500">September</h6>
              </div> */}
            </div>
            <ReactApexChart
              options={monthCart}
              series={monthCart.series}
              type="bar"
              height={350}
            />
          </div>

          {/* Weekly Top Products Card */}
          <div className="bg-white shadow rounded-lg p-6">
            <div className="flex justify-between items-center mb-4">
              <h6 className="font-semibold">Order Status</h6>
              <div className="text-end">
                <h6 className="text-gray-500">
                  {filter
                    .replace(/-/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase())}
                </h6>
              </div>
            </div>
            <ReactApexChart
              options={donutChartOptions}
              series={donutChartOptions.series}
              type="donut"
              height={350}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
